import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { toast } from "sonner";
import { Lock, User } from "lucide-react";
import { useAuth } from "../contexts/AuthContext";

export default function AdminLogin() {
  const { user, loading, login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ username: "", password: "" });
  const [submitting, setSubmitting] = useState(false);

  if (!loading && user && user.username) {
    return <Navigate to="/admin" replace />;
  }

  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await login(form.username, form.password);
      toast.success("Welcome back.");
      navigate("/admin", { replace: true });
    } catch (err) {
      const d = err?.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Login failed.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <main
      data-testid="admin-login-page"
      className="min-h-screen bg-[#1A2F24] grain relative flex items-center justify-center px-6"
    >
      <div className="w-full max-w-md bg-[#FDFBF7] p-10 md:p-12 relative">
        <a
          href="/"
          data-testid="admin-back-home"
          className="text-xs tracking-[0.18em] uppercase text-[#68766E] hover:text-[#1A2F24]"
        >
          ← Back to website
        </a>

        <div className="overline mt-6 mb-4">
          <span className="divider-gold mr-3" /> Admin
        </div>
        <h1 className="font-serif text-4xl md:text-5xl text-[#111814] leading-tight">
          Sign in to your dashboard.
        </h1>
        <p className="mt-3 text-[#68766E] text-sm">
          Restricted to Roopesh Kumar &amp; Associates.
        </p>

        <form onSubmit={onSubmit} className="mt-10 space-y-2">
          <div>
            <label className="overline text-[#68766E] flex items-center gap-2">
              <User size={12} /> Username
            </label>
            <input
              className="input-line"
              data-testid="admin-username-input"
              value={form.username}
              onChange={(e) => setForm({ ...form, username: e.target.value })}
              autoComplete="username"
              required
            />
          </div>
          <div className="pt-4">
            <label className="overline text-[#68766E] flex items-center gap-2">
              <Lock size={12} /> Password
            </label>
            <input
              type="password"
              className="input-line"
              data-testid="admin-password-input"
              value={form.password}
              onChange={(e) => setForm({ ...form, password: e.target.value })}
              autoComplete="current-password"
              required
            />
          </div>
          <button
            type="submit"
            disabled={submitting}
            className="btn-primary w-full justify-center mt-10 disabled:opacity-60"
            data-testid="admin-login-submit"
          >
            {submitting ? "Signing in..." : "Sign In"}
          </button>
        </form>
      </div>
    </main>
  );
}
